/**
 * Created by 58 on 2017/8/17.
 */
var infoQuaCheck = function (xz_opts, isShowWin) {
    var xxzlwl_opts, xxzlwl_rz_opts;
    switch (xz_opts.action_type + '') {
        case 'appeal':
            // 信息质量控制(申诉)
            var me_id = xz_opts.me.user_id + '';
            var appealer_source = xz_opts.xz_source + '';//1: 58信息 2：赶集信息 3：安居客4：老安居客5：移动经纪人6：屋米7：招财猫
            xxzlwl_opts = {
                sceneid: "97",// 申诉固定值
                userid: me_id,
                appealerid: me_id,
                appealobjid: me_id,
                appealobjtype: "2",// 1:信息，2：用户，3：消息
                appealtermsource: appealer_source,
                appealsource: appealer_source,
                type: "appeal"
            };
            break;
        case 'complaints':
            // 信息质量控制(投诉)
            var me_id = xz_opts.me.user_id + '';
            var contact_id = xz_opts.contact.user_id + '';
            var voteterm_source = xz_opts.xz_source + '';//1: 58信息 2：赶集信息 3：安居客4：老安居客5：移动经纪人6：屋米7：招财猫
            var accused_source = xz_opts.contact.user_source + '';
            xxzlwl_opts = {
                sceneid: "94", // 投诉固定值
                userid: me_id,
                voterid: me_id, // 投诉人id
                accusedid: contact_id,// 被投诉人id
                accusedobjid: contact_id,
                accusedobjtype: "2",
                votetermsource: voteterm_source,
                votesource: voteterm_source,
                accusedsource: accused_source,
                type: "complaints"
            };
            break;
        case 'faceVerify':
            // 信息质量控制(sdk认证)
            var rz_channel = xz_opts.xz_source + '';//1: 58信息 2：赶集信息 3：安居客4：老安居客5：移动经纪人6：屋米7：招财猫
            xxzlwl_rz_opts = {
                channel: rz_channel
            };
            break;
    }
    // 信质弹窗
    if (xxzlwl_opts) {
        if (isShowWin) {
            window.top.XXZLWL.Config(xxzlwl_opts);
        }
        return xxzlwl_opts;
    } else if (xxzlwl_rz_opts) {
        if (isShowWin) {
            window.top.XXZLWL.faceVerify(xxzlwl_rz_opts);
        }
        return xxzlwl_rz_opts;
    }
};

module.exports = infoQuaCheck;